if (!customElements.get('pf-showroom-tabs')) {
  customElements.define('pf-showroom-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('[role="tablist"]')) return;
      const links = Array.from(this.querySelectorAll('[data-showroom]'));
      if (links.length < 2) return;
      const list = document.createElement('div');
      list.className = 'pfe-showroom-tabs';
      list.setAttribute('role', 'tablist');
      list.setAttribute('aria-label', 'Showroom location');
      const prefix = this.closest('[id]').id + '-location';
      const panels = links.map((link, i) => {
        const panel = document.createElement('div');
        panel.id = `${prefix}-panel-${i}`;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', `${prefix}-tab-${i}`);
        link.before(panel);
        panel.append(link);
        return panel;
      });
      const select = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
      };
      const tabs = links.map((link, i) => {
        const tab = document.createElement('button');
        tab.type = 'button';
        tab.id = `${prefix}-tab-${i}`;
        tab.textContent = link.dataset.showroom;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panels[i].id);
        tab.addEventListener('click', () => select(i));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % links.length;
          if (event.key === 'ArrowLeft') next = (i - 1 + links.length) % links.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = links.length - 1;
          if (next !== undefined) { event.preventDefault(); select(next, true); }
        });
        list.append(tab);
        return tab;
      });
      this.prepend(list);
      select(0);
    }
  });
}
